import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge にデザイントークン（tailwind.config.ts）を教える。
 * 既定では `text-note` のような独自の文字サイズを文字色とみなすため、
 * 後ろに書いた `text-note` が `text-primary-foreground` を打ち消してしまい、
 * size="sm" の主要ボタンが黒地に黒文字になっていた。
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: [
        'row',
        'card-row',
        'bar-top',
        'bar-bottom',
        'sidebar',
        'sidebar-collapsed',
        'detail-pane',
        'touch',
      ],
      borderRadius: ['control', 'card', 'dialog', 'popover'],
    },
    classGroups: {
      'font-size': [
        {
          text: [
            'h1',
            'h1-sm',
            'h2',
            'h3',
            'body',
            'note',
            'metric',
            'metric-sm',
            'cell',
            'button',
            'input',
          ],
        },
      ],
      shadow: [{ shadow: ['dialog', 'popover'] }],
      'max-w': [{ 'max-w': ['content', 'content-xl'] }],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

/**
 * タブ見出しの共通クラス。
 * スマホでは 44px 以上の当たり判定を確保する（docs/09-design-system.md P05）。
 */
export const tabTriggerClass = cn(
  'flex shrink-0 items-center gap-1.5 border-b-2 px-3 text-body',
  'min-h-touch lg:min-h-0 lg:py-2',
  'transition-colors duration-hover',
  'data-[state=active]:border-foreground data-[state=active]:font-semibold data-[state=active]:text-foreground',
  'data-[state=inactive]:border-transparent data-[state=inactive]:text-foreground-muted',
);

/** ISO 日時を `<input type="datetime-local">` の値（端末のローカル時刻、分まで）に直す */
export const toDateTimeLocalInput = (iso: string): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
